import { useTranslation } from 'react-i18next'

import { FilterList, Flex, SearchFilterList } from '@percent/lemonade'
import { DisbursementsBreakdownFiltersProps } from './DisbursementsBreakdownFilters.types'

export function DisbursementsBreakdownFilters({
  organisationFilter,
  statusFilter,
  beneficiaryStatusFilter
}: DisbursementsBreakdownFiltersProps) {
  const { t } = useTranslation()

  const {
    organisationOptions,
    selectedOrganisations,
    onOrganisationChange,
    isOrganisationFilterLoading,
    organisationSearch
  } = organisationFilter

  const { statusesOptions, selectedStatuses, onStatusChange } = statusFilter

  return (
    <Flex gap={4} align="center">
      <SearchFilterList
        options={organisationOptions}
        isLoading={isOrganisationFilterLoading}
        selectedValues={selectedOrganisations}
        onChange={onOrganisationChange}
        searchValue={organisationSearch.organisationSearchValue}
        onSearchChange={organisationSearch.onOrganisationSearchChange}
        handleClearValue={organisationSearch.onClearOrganisationSearchValue}
        onKeyDown={organisationSearch.handleKeyPress}
        onButtonClick={organisationSearch.onOrganisationsSearchButtonClick}
        testId="disbursements-breakdown-organisation-search-filter"
        buttonText={t('typography.search')}
        placeholder={t('typography.searchByOrganisationNameOrId')}
        label={t('typography.organisation')}
        placement="bottom-end"
        noResultsFoundText={
          organisationSearch.organisationSearchValue.length < 3 ? t('typography.enterAtLeast3Characters') : undefined
        }
      />
      <FilterList
        label={t('typography.status')}
        options={statusesOptions}
        selectedValues={selectedStatuses}
        onChange={onStatusChange}
        testId="disbursements-breakdown-status-filter"
        placement="bottom-end"
      />
      {beneficiaryStatusFilter && (
        <FilterList
          label={t('table.beneficiary')}
          options={beneficiaryStatusFilter.beneficiaryStatusesOptions}
          selectedValues={beneficiaryStatusFilter.selectedBeneficiaryStatuses}
          onChange={beneficiaryStatusFilter.onBeneficiaryStatusChange}
          testId="disbursements-breakdown-beneficiary-filter"
          placement="bottom-end"
        />
      )}
    </Flex>
  )
}
